module.exports = __webpack_public_path__ + "static/media/balance-r.bbf20b38.svg";